export default "__VITE_ASSET__COahgozk__"